export default "__VITE_ASSET__BAlKG0GL__"